import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  className: PropTypes.string,
  xmlns: PropTypes.string,
  xlink: PropTypes.string,
  viewBox: PropTypes.string.isRequired
}

const defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink'
}

const Svg = props => <svg {...props} />

Svg.propTypes = propTypes
Svg.defaultProps = defaultProps

export default Svg
